import React, { useEffect, useState } from 'react'
import Chart from 'react-apexcharts'
import { Spin } from 'antd'

const Heatmap = React.memo(({ graph_id = '', graph_data = [] }) => {

    const [isLoading, setIsLoading] = useState(true)

    const series = Object.keys(graph_data[0] || {})
        .filter(key => key !== "xAxis_date")
        .map(key => ({
            name: key.replace(/^yAxis_/, '').replace(/_/g, ' '),
            data: graph_data.map(item => ({
                x: item.xAxis_date,
                y: item[key]
            }))
        }))

    const options = {
        chart: {
            id: graph_id || 'heat_map',
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            heatmap: {
                shadeIntensity: 0.5,
                colorScale: {
                    ranges: [
                        { from: 0, to: 0, color: "#f20c1b" },
                        { from: 1, to: 1, color: "#1bf20c" },
                    ],
                },
            },
        },
        xaxis: {
            labels: {
                style: {
                    colors: '#b8b8b8',
                    fontSize: '10px',
                    fontWeight: 500,
                },
            },
            tickAmount: 10,
        },
        yaxis: {
            labels: {
                style: {
                    colors: '#b8b8b8',
                    fontSize: '10px',
                    fontWeight: 500,
                },
                formatter: (value) => {
                    if (!value) return ''
                    return value.length > 12 ? `${value.substring(0, 12)}...` : value
                },
            },
        },
        tooltip: {
            theme: "dark",
            style: {
                fontSize: '12px',
            },
        },
        markers: {
            size: 3,
            strokeColors: '#fff',
            strokeWidth: 0.8,
            hover: {
                size: 6
            }
        },
        grid: {
            show: false,
            borderColor: '#e5e5e5'
        },
        legend: {
            show: false,
            fontSize: '10px',

            markers: {
                size: 5,
                strokeWidth: 0,
                shape: 'circle',
            },
        },
        stroke: {
            show: true,
            curve: 'smooth',
        },
        dataLabels: {
            enabled: false
        },
    }

    useEffect(() => {
        if (graph_data.length) {
            const timeout = setTimeout(() => setIsLoading(false), 500)
            return () => clearTimeout(timeout)
        }
    }, [graph_data])

    return (
        <div
            style={{
                overflow: "hidden",
                width: '100%',
                height: '96%'
            }}
        >
            {isLoading ? (
                <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Spin size="large" />
                </div>
            ) : (
                <div
                    style={{
                        width: "100%",
                        whiteSpace: "nowrap",
                        height: "100%"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-around",
                            alignItems: "center",
                            marginBottom: "5px"
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px"
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: "#54f549",
                                    height: "15px",
                                    width: "15px"
                                }}
                            ></div>
                            <span
                                style={{
                                    color: '#fff',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                }}
                            >
                                Active
                            </span>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "10px"
                            }}
                        >
                            <div
                                style={{
                                    backgroundColor: "#f9868d",
                                    height: "15px",
                                    width: "15px"
                                }}
                            ></div>
                            <span
                                style={{
                                    color: '#fff',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                }}
                            >
                                Inactive
                            </span>
                        </div>
                    </div>
                    <Chart
                        options={options}
                        series={series}
                        type="heatmap"
                        width="100%"
                        height="100%"
                    />
                </div>
            )}
        </div>
    )
})

export default Heatmap